import { formatInTimeZone } from 'date-fns-tz'
import { ptBR } from 'date-fns/locale'

/**
 * Fuso da Prefeitura, fixado.
 *
 * A API responde instantes em UTC (`Instant`, sufixo Z). Formatar com o fuso do
 * navegador faria a mesma transição aparecer em horas diferentes para quem acessa
 * de fora — e a trilha de auditoria precisa bater com a ata do comitê.
 */
export const FUSO_NITEROI = 'America/Sao_Paulo'

/** @returns data e hora legíveis, ou o texto vazio quando não há valor. */
export function dataHora(instante: string | null | undefined, vazio = '—'): string {
  return formatar(instante, "dd/MM/yyyy 'às' HH:mm", vazio)
}

/** @returns só a data, para colunas de tabela onde a hora é ruído. */
export function data(instante: string | null | undefined, vazio = '—'): string {
  return formatar(instante, 'dd/MM/yyyy', vazio)
}

/**
 * Uma data SEM hora — `AAAA-MM-DD` — escrita como se lê.
 *
 * **Não converte fuso, e é por isso que ela existe.** `new Date('2026-09-02')` é interpretado como
 * meia-noite em UTC; formatado no fuso de Niterói (UTC−3) ele volta como **01/09/2026**, um dia
 * antes. O defeito é silencioso e mora justamente nos campos que vão para documento: a data em que
 * uma ocorrência administrativa aconteceu, a data em que um relatório da contratada chegou. Um dia
 * a menos numa dessas é o tipo de coisa que a contratada contesta — e com razão.
 *
 * Data sem hora não tem fuso: ela é o que está escrito. Por isso a formatação é textual, e não
 * passa por `Date`.
 *
 * Para INSTANTES (com hora, sufixo Z) use {@link data} — ali a conversão é necessária e correta.
 *
 * @param iso a data no formato `AAAA-MM-DD`
 * @param vazio o que mostrar quando não há valor
 * @returns a data em `dd/MM/aaaa`
 */
export function dataSimples(iso: string | null | undefined, vazio = '—'): string {
  if (!iso) {
    return vazio
  }
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso)
  if (!partes) {
    return vazio
  }
  return `${partes[3]}/${partes[2]}/${partes[1]}`
}

/** @returns data e hora por extenso, para o atributo `title` e leitores de tela. */
export function dataHoraPorExtenso(instante: string | null | undefined, vazio = '—'): string {
  return formatar(instante, "d 'de' MMMM 'de' yyyy, 'às' HH:mm", vazio)
}

function formatar(instante: string | null | undefined, padrao: string, vazio: string): string {
  if (!instante) {
    return vazio
  }
  const quando = new Date(instante)
  if (Number.isNaN(quando.getTime())) {
    // Data inválida vinda da API é bug de contrato, não motivo para a tela quebrar.
    return vazio
  }
  return formatInTimeZone(quando, FUSO_NITEROI, padrao, { locale: ptBR })
}
